import { ChangeDetectionStrategy, Component, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReleaseNotesComponent implements AfterViewInit {
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ReleaseNotesComponent>,
  ) { }

  releaseNotes = [
    {
      Expanded: true,
      ReleaseDate: new Date('August 13, 2025'),
      Title: 'Real-Time Investment Account Details',
      Description: 'We\'re excited to announce a powerful new feature in Alphastar\'s Advisor Portal: Real-time Investment Account Details. This update provides immediate, comprehensive access to client account information through two new views, giving a complete picture of client investments in real time.',
      WhatsNew: 'Advisors will now find a new view for Investment Account Details with two dedicated tabs:',
      New: [
        {
          Point: 'Overview Tab',
          Description: 'This tab provides a high-level summary of the account, perfect for quick reference and client conversations. The <b>Overview</b> tab includes:',
          SubPoints: [
            '<b>Account Title & Details:</b> A clear view of the account title and primary account information.',
            '<b>Beneficiaries:</b> Easily confirm the designated beneficiaries on file.',
            '<b>Money Managers:</b> See who is managing the funds within the account.',
            '<b>Account Values:</b> Get an up-to-the-minute look at the total account value.',
            '<b>Available Funds:</b> Quickly identify funds available for withdrawal and funds available to trade, simplifying liquidity management.'
          ]
        },
        {
          Point: 'Sleeves Tab',
          Description: 'For a more granular view, the <b>Sleeves</b> tab gives real-time insight into the underlying structure of the account. This includes:',
          SubPoints: [
            '<b>Real-Time Sleeves:</b> See each individual investment sleeve within the account.',
            '<b>Associated Models:</b> View the specific investment models assigned to each sleeve.',
            '<b>Sleeve Values & Positions:</b> Get a detailed breakdown of the value and individual positions within each sleeve.',
          ]
        },
      ],
      Benefits: [
        {
          Point: '<b>Comprehensive Visibility:</b> Access all key account information, from high-level summaries to detailed positions, in one place.',
          Description: '',
          SubPoints: [],
        },
        {
          Point: '<b>Real-Time Data:</b> Make more informed decisions with up-to-the-minute account values and positions.',
          Description: '',
          SubPoints: [],
        },
        {
          Point: '<b>Increased Efficiency:</b> Eliminate the need to navigate multiple screens or reports to get the full picture of an account.',
          Description: '',
          SubPoints: [],
        },
        {
          Point: '<b>Better Client Conversations:</b> Have all the necessary details at your fingertips to answer client questions quickly and confidently.',
          Description: '',
          SubPoints: [],
        },
      ],
      Access: [
        {
          Point: 'Log in to the Portal and select a client account from the Accounts list. You will see the new Investment Account Details view with the Overview and Sleeves tabs available for immediate use.',
          SubPoints: [],
        }
      ]
    },
    {
      Expanded: false,
      ReleaseDate: new Date('July 12, 2025'),
      Title: 'Enhanced Contribution & Distribution Requests',
      Description: 'We\'ve updated your Advisor Portal to make Contribution and Distribution Service Requests even easier and more secure! This release integrates crucial Schwab Tax Withholding, Banking Information on File, and new Workflow Alerts directly into the request process, saving you time, reducing errors, and enhancing compliance.',
      New: [
        {
          Point: 'Integrated Custodian Tax Withholding:',
          Description: '',
          SubPoints: [
            'For distributions, see pre-populated tax allocations (federal and state)',
          ]
        },
        {
          Point: 'Visible Banking Information on File:',
          Description: '',
          SubPoints: [
            'For requests, simply see the primary banking details on file with Schwab.',
            'Verify information instantly, reducing rejections from incorrect banking details.',
          ]
        },
        {
          Point: 'Intelligent Workflow Alerts:',
          Description: '',
          SubPoints: [
            'Standing Instruction Alerts: Get immediate alerts if a request conflicts with or aligns with existing client standing instructions on file preventing errors and ensuring adherence to client preferences.',
            'IA Authority Alerts: Receive proactive notifications and guidance based on your Investment Advisor (IA) authority levels, ensuring compliance with established permissions.',
          ]
        },
      ],
      Benefits: [
        {
          Point: 'Increased Efficiency: Faster request processing with less back-and-forth.',
          Description: '',
          SubPoints: [],
        },
        {
          Point: 'Reduced Errors: Minimize mistakes from manual entry or outdated information.',
          Description: '',
          SubPoints: [],
        },
        {
          Point: 'Enhanced Transparency: Immediate access to critical tax and banking details.',
          Description: '',
          SubPoints: [],
        },
        {
          Point: 'Improved Compliance: Automated checks and alerts based on IA authority and standing instructions.',
          Description: '',
          SubPoints: [],
        },
        {
          Point: 'Smarter Workflow: Proactive guidance to streamline your request submissions.',
          Description: '',
          SubPoints: [],
        },
      ],
      Access: [
        {
          Point: 'Start a new Contribution or Distribution Service Request. The new features are seamlessly integrated into the existing workflow.',
          SubPoints: [],
        }
      ]
    },
  ];

  closeRequest(): void {
    this.dialogRef.close(false);
  }

  ngAfterViewInit(): void {
    const width = '90rem';
    const height = '84rem';
    this.dialogRef.updateSize(width, height);
  }
}
